export default __webpack_public_path__ + "static/media/Leggings of Bristling Ire.45d59f8b.jpg";